<div class="gen-chart-container">
  <dx-toolbar class="toolbar">
    <dxi-item location="center">
      <div *dxTemplate class="chart-buttons">
        <dx-button icon="print" text="Yazdır" stylingMode="text" (onClick)="printChart()"></dx-button>
        <dx-button text="PNG" stylingMode="text" (onClick)="exportChart('png')"></dx-button>
        <dx-button text="JPEG" stylingMode="text" (onClick)="exportChart('jpeg')"></dx-button>
        <dx-button text="SVG" stylingMode="text" (onClick)="exportChart('svg')"></dx-button>
      </div>
    </dxi-item>
    <dxi-item location="after" *ngIf="showToolbarLegendButton || showGridButton">
      <div *dxTemplate>
        <dx-button
          *ngIf="showToolbarLegendButton"
          icon="bulletlist"
          text="Lejant"
          [stylingMode]="legendVisible ? 'contained' : 'text'"
          [hint]="legendVisible ? 'Lejantı Gizle' : 'Lejantı Göster'"
          (onClick)="toggleLegend()"
        ></dx-button>
        <dx-button *ngIf="showGridButton" text="Grid" [width]="'90px'" (onClick)="closeChart()"></dx-button>
      </div>
    </dxi-item>
  </dx-toolbar>

  <dx-load-panel [visible]="isLoading"></dx-load-panel>

  <dx-chart *ngIf="!isCircular" class="chart" [dataSource]="numericRows">
    <dxo-common-series-settings
      [argumentField]="argumentField"
      [valueField]="seriesField ? firstValueField : ''"
      [type]="seriesType"
    ></dxo-common-series-settings>

    <dxi-series
      *ngFor="let vs of !seriesField ? valueSeriesInfo : []"
      [valueField]="vs.field"
      [name]="vs.field"
      [type]="vs.type"
      [axis]="vs.axis"
    ></dxi-series>
    <dxo-series-template *ngIf="seriesField" [nameField]="seriesField"></dxo-series-template>

    <!--
      Çok kategorili sorgularda (örn. tüm birimler) DevExtreme varsayılan olarak
      sığmayan x-ekseni etiketlerini SESSİZCE gizliyordu - "bazı sütunların
      etiketi hiç yazılmıyor" görüntüsü buradan geliyordu. overlappingBehavior/
      displayMode="rotate" ile hiçbiri gizlenmiyor, hepsi döndürülerek basılıyor
      (bkz. aynı çözümün teb-gelir-gider-toplam.component.html'de de kullanılması).
    -->
    <dxo-argument-axis>
      <dxo-label
        overlappingBehavior="rotate"
        displayMode="rotate"
        [rotationAngle]="-45"
      ></dxo-label>
    </dxo-argument-axis>

    <!--
      SERIES_AXIS='secondary' ayarı taşıyan en az bir kolon varsa (bkz.
      gen-chart.component.ts valueSeriesInfo), o serilerin bağlanacağı adlı
      eksen burada açılıyor. Named eksen eklenince DevExtreme varsayılan
      (isimsiz) ekseni artık örtük eklemiyor - bu yüzden primary eksen de
      burada elle tanımlanmak zorunda.
    -->
    <ng-container *ngIf="hasSecondaryAxis">
      <dxi-value-axis>
        <dxo-grid [visible]="true"></dxo-grid>
      </dxi-value-axis>
      <dxi-value-axis name="secondary" position="right">
        <dxo-grid [visible]="true"></dxo-grid>
      </dxi-value-axis>
    </ng-container>

    <dxo-legend
      [visible]="legendVisible"
      verticalAlignment="top"
      horizontalAlignment="center"
      itemTextPosition="right"
    ></dxo-legend>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
    <dxo-size [height]="480"></dxo-size>
  </dx-chart>

  <dx-pie-chart *ngIf="isCircular" class="chart" [dataSource]="circularRows" [type]="pieType">
    <dxi-series [argumentField]="argumentField" [valueField]="firstValueField">
      <dxo-label [visible]="true" [customizeText]="customizePieLabel">
        <dxo-connector [visible]="true" [width]="0.5"></dxo-connector>
      </dxo-label>
    </dxi-series>
    <dxo-legend
      [visible]="legendVisible"
      verticalAlignment="bottom"
      horizontalAlignment="center"
      itemTextPosition="right"
      [columnCount]="legendColumnCount"
      [markerSize]="10"
      [font]="{ size: 10 }"
    ></dxo-legend>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
    <dxo-size [height]="480"></dxo-size>
  </dx-pie-chart>
</div>
